import { render, staticRenderFns } from "./djgrz.vue?vue&type=template&id=19788c00&scoped=true&"
import script from "./djgrz.vue?vue&type=script&lang=js&"
export * from "./djgrz.vue?vue&type=script&lang=js&"
import style0 from "./djgrz.vue?vue&type=style&index=0&id=19788c00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19788c00",
  null
  
)

export default component.exports